import { ConfirmationModal } from "@/components/ui";
import type { AttributeReviewMappingRow } from "@/hooks/useAttributeReview.types";
import { requiredWarning } from "@/lib/attributeReview/requiredWarning";

type Props = {
  row: AttributeReviewMappingRow | null;
  onCancel: () => void;
  onConfirm: (row: AttributeReviewMappingRow) => void;
};

export function IgnoreConfirm({ row, onCancel, onConfirm }: Props) {
  return (
    <ConfirmationModal
      open={row !== null}
      onOpenChange={(open) => !open && onCancel()}
      variant="danger"
      title={`Ignore ${String(row?.sourceAttribute ?? "this field")}?`}
      description={requiredWarning(row?.requirementLevel)?.message}
      confirmLabel="Ignore"
      onConfirm={() => {
        if (row) onConfirm(row);
        onCancel();
      }}
    />
  );
}
